import { useTranslation } from 'react-i18next'

import { AcquiringItem, RefillType } from 'app/dataTypes/acquiring/settings'
import { useAcquiringOrder } from 'app/dataProviders/acquiring/order/hooks'
import { StatusMessage } from 'app/common/templates-next/page-template'
import { BankCardId } from 'app/dataTypes/acquiring/recurrent/cards'

import RefillLoading from './RefillLoading'
import RedirectToBank from './RedirectToBank'

import styles from './Order.module.scss'

type Props = {
  acquiringItem: AcquiringItem
  amount: number
  refillType: RefillType
  successURL: string
  failureURL: string
  recurrent?: { bankId: BankCardId } | { save: boolean } | {}
}

const Order = ({ acquiringItem, amount, refillType, successURL, failureURL, recurrent }: Props) => {
  const { t } = useTranslation('finances')

  const { id, ownerType, pageType } = acquiringItem

  const { loading, order } = useAcquiringOrder({
    id,
    ownerType,
    refillType,
    amount,
    successURL: pageType === 'window' ? successURL : null,
    failureURL: pageType === 'window' ? failureURL : null,
    ...(recurrent && 'bankId' in recurrent ? { recurrentCardId: recurrent.bankId } : {}),
    ...(recurrent && 'save' in recurrent ? { recurrentSave: recurrent.save } : {}),
  })

  if (loading) {
    return <RefillLoading itemsCount={1} />
  }

  if (!order) {
    return <StatusMessage skipPadding>{'Произошла непредвиденная ошибка'}</StatusMessage>
  }

  return (
    <div className={styles.root}>
      {pageType === 'window' && <RedirectToBank redirectTo={order.payURL} />}
      {pageType === 'frame' && (
        <iframe
          src={order.payURL}
          scrolling="no"
          className={styles.frame}
          title={t('frame_title', 'Банк') as string}
          allow="payment; clipboard-write"
          referrerPolicy="no-referrer-when-downgrade"
        >
          {t(
            'frame_error',
            'Извините, Ваш браузер не поддерживает встроенные фреймы, Вы не сможете пополнить счет! Попробуйте в другом браузере.',
          )}
        </iframe>
      )}
      {pageType !== 'window' && pageType !== 'frame' && (
        <StatusMessage skipPadding>{'Ошибка в данных ордера эквайринга (page_type)'}</StatusMessage>
      )}
    </div>
  )
}

export default Order
